export const mediaQueryMinWidth = (size: number): string =>
  `@media only screen and (min-width: ${size}px)`;

export const mediaQueryMaxWidth = (size: number): string =>
  `@media only screen and (max-width: ${size}px)`;
